import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check, BookOpen } from 'lucide-react';
export function Hero() {
  const benefits = ['a soltar cargas emocionales sin culpa', 'a poner límites sin sentirte mala', 'a cerrar ciclos sin miedo a soltar', 'a recuperar tu energía emocional poco a poco'];
  return <section className="relative pt-8 pb-12 md:pt-16 md:pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-16">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-2 lg:order-1" data-id="element-17">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight mb-5 text-[#5C4A3A]" data-id="element-18">
              No estás rota. <br data-id="element-19" />
              <span className="text-[#D69065] italic" data-id="element-20">
                Estás cansada de cargar con todo.
              </span>
            </h1>

            <p className="text-base md:text-lg text-[#5C4A3A]/80 mb-6 leading-relaxed" data-id="element-21">
              Si te sientes agotada por dentro, atrapada entre dar demasiado, no
              poder decir no y un pasado que aún pesa… esta guía es tu punto de
              inicio para soltar lo que ya no te deja avanzar, recuperar tus
              límites y empezar un nuevo camino con calma.
            </p>

            <div className="bg-white/50 rounded-2xl p-5 mb-6 border border-[#E8A87C]/20" data-id="element-22">
              <h3 className="font-serif text-lg font-semibold mb-3 text-[#5C4A3A]" data-id="element-23">
                En esta guía aprenderás:
              </h3>
              <ul className="space-y-2" data-id="element-24">
                {benefits.map((benefit, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -10
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 0.5 + index * 0.1
              }} className="flex items-start" data-id="element-25">
                    <Check className="h-4 w-4 text-[#E8A87C] mt-1 mr-2 flex-shrink-0" data-id="element-26" />
                    <span className="text-[#5C4A3A]/90 text-sm" data-id="element-27">{benefit}</span>
                  </motion.li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:items-start gap-3" data-id="element-28">
              <div className="flex flex-col gap-2" data-id="element-29">
                <div className="flex items-center gap-3" data-id="element-30">
                  <span className="text-[#5C4A3A]/40 line-through text-base" data-id="element-31">
                    US$19.97
                  </span>
                  <span className="bg-[#E8A87C] text-white px-2.5 py-0.5 rounded-full text-xs font-bold" data-id="element-32">
                    68% OFF
                  </span>
                </div>
                <Button className="w-full sm:w-auto text-lg px-8 py-4" scrollToId="cta-final" data-id="element-33">
                  Comprar ahora — US$6.39
                </Button>
              </div>
              <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-xs text-[#5C4A3A]/70" data-id="element-34">
                <span className="flex items-center" data-id="element-35">
                  <BookOpen className="h-3.5 w-3.5 mr-1.5" data-id="element-36" />
                  Descarga inmediata + acceso por email
                </span>
                <span className="hidden sm:inline" data-id="element-37">•</span>
                <span className="font-semibold text-[#E8A87C]" data-id="element-38">
                  Garantía 7 días
                </span>
              </div>
              <p className="text-xs text-[#5C4A3A]/50 uppercase tracking-wider font-medium mt-1" data-id="element-39">
                Formato: PDF — 49 páginas
              </p>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="order-1 lg:order-2 flex justify-center" data-id="element-40">
            <div className="relative" data-id="element-41">
              <div className="absolute inset-0 bg-[#E8A87C]/10 rounded-full blur-3xl transform scale-90 translate-y-10 -z-10" data-id="element-42" />
              <img src="https://cdn.magicpatterns.com/uploads/jkAepL8kKUFEokydibcND8/Mockup_del_libro_Transforma....png" alt="Transforma tu Vida: Un Nuevo Comienzo - Libro en tablet y móvil" className="w-full max-w-md lg:max-w-full h-auto drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-700 ease-in-out" data-id="element-43" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}